import React from 'react';

import { GicAnywhere } from '@atlassian/gic-anywhere';

import { SidePanelBody } from '@confluence/side-panel';

import type { IssueCreateSidePanelBodyProps } from './__types__/IssueCreateSidePanelBody';

const noop = () => {};

export const IssueCreateSidePanelBody = ({
	onClose,
	summary = '',
	isCreatedWithAi,
}: IssueCreateSidePanelBodyProps) => {
	return (
		<>
			{isCreatedWithAi ? (
				// REMOVE AND REPLACE WITH JIRA ISSUE AI CREATE COMPONENT WHEN IMPLEMENTING https://hello.jira.atlassian.cloud/browse/CBT-3885
				<div data-testid="ai-component-placeholder">AI Component Placeholder</div>
			) : (
				<SidePanelBody>
					<GicAnywhere
						consumer="confluence-highlight-issue-create"
						onSuccess={noop}
						onClose={onClose}
						onFailure={noop}
						summary={summary}
					/>
				</SidePanelBody>
			)}
		</>
	);
};
